import getFileExtension from '@framework/data-helpers/string/getFileExtension';
import mapFileExtensionToIcon from '@creditflowresearch/uilib/utils/mapFileExtensionToIcon';
import { mapExtensionToColor } from '@framework/data-helpers/color';

import styles from '../styles.module.scss';

interface IProps {
  item: { name: string, url: string, displayName: string, uploadId: string },
  dataTest: string,
  onClick?: (item: { displayName: string, uploadId: string }) => void,
}

const DowloadFileLink = ({
  item,
  onClick,
  dataTest,
}: IProps) => {
  const onItemClick = () => {
    onClick(item);
  };
  const fileExtention = getFileExtension(item.name);
  const IconComponent = mapFileExtensionToIcon(fileExtention);
  const color = mapExtensionToColor(fileExtention);
  return (
    <div className={ styles.downloadItem } onClick={ onItemClick } data-test={ `${ dataTest }DownloadLink` }>
      <IconComponent
        style={ { fill: color } }
        className={ styles.downloadItemIcon }
      />
      <p className={ styles.downloadItemName }>{ item.name }</p>
    </div>
  );
};

export default DowloadFileLink;
